import {
  DialogTitle, ModalDialog, DialogContent, Stack, FormControl, FormLabel, ModalClose,
  Select, Button, Modal, Option
} from "@mui/joy";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, } from "react-redux";
import { IUser } from "../../interface/IUser";
import { incrementUser } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";


// let roleForUser =[
//   {id: 1,	role: "Picker"},
//   ]
export default function ProfileModalDialog(props: any) {
  const userinfo: IUser = useSelector((state: any) => state.user)
  const [currentRole, setCurrentRole] = React.useState<any>(userinfo?.userRoleName || 'Picker');
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [roleForUser, SetroleForUser] = useState([
    { id: 1, role: "Picker" },
  ])
  useEffect(() => {    
    SetroleForUser(userinfo.userRoles);

  }, []);

  function callsetOpenRoleDialog() {
    props.setOpenRoleDialog(false);
  };
  const handleChangeRole = (
    event: React.SyntheticEvent | null,
    newValue: string,
  ) => {
    setCurrentRole(newValue);
  }

  function handleChange() {


    let loginUserData: IUser = { ...userinfo }
    loginUserData.userRoleName = currentRole
    loginUserData.userRoleId = roleForUser.find((ur) => { if (ur.role === currentRole) return true })?.id || 1
    dispatch(incrementUser(loginUserData))
    navigate('/orders')

  }

  return (
    <>
      <Modal open={props.openRoleDialog} onClose={() => { callsetOpenRoleDialog() }}>
        <ModalDialog>
          <ModalClose />
          <DialogTitle>Change Role</DialogTitle>
          <DialogContent>Select from availble Role options</DialogContent>
          <form
            onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              callsetOpenRoleDialog();
              handleChange();

            }}
          >
            <Stack spacing={2}>
              <FormControl>
                <FormLabel key='name'>Name: {userinfo?.userName}</FormLabel>
                <FormLabel key='role'>Role: {userinfo?.userRoleName}</FormLabel>
                <Select key='changerole' defaultValue={currentRole} onChange={handleChangeRole}>
                  {roleForUser.map((role, index) => (
                    <Option key={role.id} value={role.role}>{role.role}</Option>
                  ))}
                </Select>
              </FormControl>
              <Button type="submit">Submit</Button>
            </Stack>
          </form>
        </ModalDialog>
      </Modal>
    </>
  );
}